import { View } from 'react-native';

import { DocumentTitle } from '@/components/layout/DocumentTitle';
import { Text } from '@/components/ui';

export function SearchEmptyState() {
  return (
    <View className="chat-pane flex min-h-0 flex-1 items-center justify-center px-page py-page-y">
      <DocumentTitle title="Search" />
      <Text variant="body" className="max-w-sm text-center text-muted">
        Select a page from the sidebar to open it here.
      </Text>
    </View>
  );
}
